import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ea1a20c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2ea1a20c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea1a20c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ea1a20c')) {
      api.createRecord('2ea1a20c', component.options)
    } else {
      api.reload('2ea1a20c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ea1a20c&scoped=true", function () {
      api.rerender('2ea1a20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/navBars/index.vue"
export default component.exports